<template>
  <base-section-layout
    title="赴馆携带资料"
    icon="https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdv-www/order/order-interview-notification/section-material.png"
    is-radius-top
  >
    <div class="applicant-list">
      <div
        v-for="(item, index) in interviewData.interview"
        :key="index"
        class="applicant-block"
      >
        <div class="applicant-head">
          <div class="applicant-name">
            {{ getApplicantNames(item.applicant) }}
          </div>
          <div class="identity-tag">{{ item.identity }}</div>
        </div>

        <section-carry-material-group
          v-if="item.material_delivered && item.material_delivered.length"
          :title="
            interviewData.companion_name
              ? '以下资料将由陪签员携带至使馆现场'
              : '您将收到以下邮寄资料，请携带至使馆现场'
          "
          :list="item.material_delivered"
        />

        <section-carry-material-group
          title="以下资料需要您自行准备携带至使馆现场"
          :list="item.material_prepared"
        />
      </div>
    </div>
  </base-section-layout>
</template>

<script>
import BaseSectionLayout from './BaseSectionLayout.vue';
import SectionCarryMaterialGroup from './SectionCarryMaterialGroup.vue';

export default {
  name: 'SectionCarryMaterial',
  components: {
    BaseSectionLayout,
    SectionCarryMaterialGroup,
  },
  props: {
    interviewData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    getApplicantNames(applicant) {
      if (!applicant) return '';
      if (Array.isArray(applicant)) return applicant.join('、');
      return applicant;
    },
  },
};
</script>

<style lang="less" scoped>
.applicant-list {
  .applicant-block {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .applicant-head {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 0.5px solid #e9eef2;
  }

  .applicant-name {
    color: #333;
    font-size: 13px;
    font-weight: 500;
    line-height: 21px;
  }

  .identity-tag {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    height: 16px;
    margin-left: 8px;
    padding: 0 4px;
    border: 0.5px solid #c9cdd1;
    border-radius: 2px;
    color: #a6a6a6;
    background: #fff;
    font-size: 11px;
    line-height: 1;
  }
}
</style>
